<template>
    <div id="registryEditRulePanel" class="form-wrapper">

        <PanelDropdown v-model="localForm.registryHive" :label="$t('registryHive')" :options="registryHiveOptions"
            placeholder="None" :tooltip="$t('tooltips.registryAccess.registryHive')" />
        <FolderFileName v-model="localForm.registryKey" :max-length="260" :titleLabel="$t('registryKey')"
            :tooltip="$t('tooltips.registryAccess.registryKey')" :placeholder="t('enterRegistryKey')"
            :errorMessage="registryKeyError" :isInvalid="!!registryKeyError" @validation="onValidation" />
        <FolderFileName v-model="localForm.registryValue" :max-length="260" :titleLabel="$t('registryValue')"
            :tooltip="$t('tooltips.registryAccess.registryValue')" :placeholder="t('enterRegistryValue')"  />
        <PanelDropdown v-model="localForm.accessControl" :label="$t('accessControl')" :options="accessControlOptions"
            placeholder="" :tooltip="$t('tooltips.registryAccess.accessControl')" />
        <PanelDropdown v-model="localForm.appliesTo" :label="$t('appliesTo')" :options="appliesToOptions" placeholder=""
            :tooltip="$t('tooltips.registryAccess.appliesTo')" />
        <ExpertNotes v-model="localForm.expertNotes" :max-length="1000" :label="t('expertNotes')" />
    </div>
</template>

<script setup>
import { defineProps, ref, watch, defineEmits, computed } from 'vue'
import PanelInput from './components/panelInput.vue'
import PanelDropdown from './components/panelDropdown.vue'
import { useStore } from "@/store";
import ExpertNotes from './components/expertNotes.vue';
import FolderFileName from './components/folderFileName.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const props = defineProps({
    form: {
        type: Object,
        required: true,
    },
    formType: {
        type: String,
        default: 'registry'
    },
    enumKey: {
        type: String,
        default: 'AccessControl'
    }
})
const emit = defineEmits(['update:form', 'validation'])
const store = useStore();
const registryKeyError = ref('');
const localForm = computed({
    get() {
        return props.form;
    },
    set(newVal) {
        emit('update:form', newVal);
    }
});

const accessControlOptions = computed(() => {
    return store.state.general.enums[props.enumKey] || [];
});

const appliesToOptions = computed(() => store.state.general.enums['AppliesTo'] || [])
const registryHiveOptions = computed(() => store.state.general.enums['RegistryHive'] || [])

const validateRegistryKey = (key) => {
    // if (!key) {
    //     return 'Registry key cannot be empty.';
    // }
    const forbiddenCharsRegex = /[/?"<>|]/;
    if (forbiddenCharsRegex.test(key)) {
        return t('registryKeyError');
    }
    return '';
};

watch(() => localForm.value.registryKey, (newVal) => {
    registryKeyError.value = validateRegistryKey(newVal);
}, { immediate: true });

function onValidation(valid){
    emit('validation', valid)
}
</script>
<style>
.form-wrapper {
    font-size: 0.8rem !important;
}

.custom-input {
    width: inherit;
}

.label-check {
    margin-left: 5px;
    margin-bottom: 0px !important;
}

.form-label {
    color: #164B6C;
    font-weight: bold;
    margin-left: 8px;
}

.info-icon {
    margin-left: 3px;
}
</style>
